<template>
  <div>
    <div
      class="btn-group-toggle d-flex user-account-tab border-t"
      data-toggle="buttons"
    >
      <div class="uni-max-sm">
        <label :class="`btn btn-secondary col agent-prop-tab ${show_target == 'watch_list' ? 'active' : ''}`">
          <input type="radio" name="tab" :checked="show_target == 'watch_list'" @click="toggleShow('watch_list')" />
          <span>Watch List</span>
        </label>
        <label :class="`btn btn-secondary col agent-prop-tab ${show_target == 'comparison' ? 'active' : ''}`" style="min-width: 180px">
          <input type="radio" name="tab" :checked="show_target == 'comparison'" @click="toggleShow('comparison')" />
          <span>Compare Records</span>
        </label>
        <label :class="`btn btn-secondary col agent-prop-tab ${show_target == 'alert_setting' ? 'active' : ''}`" style="min-width: 240px">
          <input type="radio" name="tab" :checked="show_target == 'alert_setting'" @click="toggleShow('alert_setting')" />
          <span>Automated Property Matching</span>
        </label>
      </div>
    </div>

    <div v-show="show_target == 'watch_list'">
        <watch-list></watch-list>
    </div>
    <div v-show="show_target == 'comparison'">
        <comparison-list></comparison-list>
    </div>
    <div v-show="show_target == 'alert_setting'">
        <property-matching-form></property-matching-form>
        <!-- <property-matching-list></property-matching-list> -->
    </div>
  </div>
</template>

<script>
import watchList from './watchList.vue';
export default {
  components: { watchList },
  name: "account-tab",
  data() {
    return {
        show_target: 'alert_setting'
    };
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("tab")) {
      this.show_target = urlParams.get("tab");
    }
  },
  methods: {
    toggleShow: function(target) {
        this.show_target = target;
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
    }
  }
};
</script>